import { HospitalModel } from "@common/models";
import { HospitalPrescriptionRefillStatus } from "@common/models/Enums";
import { AddHospitalPrescriptionRefillRequest } from "@common/models/requests/AddHospitalPrescriptionRefillRequest";
import { CheckOutHospitalPrescriptionRefillRequest } from "@common/models/requests/CheckOutHospitalPrescriptionRefillRequest";
import { UpdateHospitalPrescriptionRefillRequest } from "@common/models/requests/UpdateHospitalPrescriptionRefillRequest";
import { HospitalService } from "@common/services";
import { NotificationStoreInstance } from "@common/stores";
import { flow, makeObservable, observable } from "mobx";

export class HospitalPrescriptionRefillStore {
    @observable currentHospital: HospitalModel;

    constructor(init: { currentHospital: HospitalModel }) {
        this.currentHospital = init.currentHospital;
        makeObservable(this, undefined, { autoBind: true });
    }

    createHospitalPrescriptionRefill = flow(function* (this: HospitalPrescriptionRefillStore, hospitalPrescriptionId: number, hospitalPrescriptionRefillStatusId: number, hospitalPrescriptionRowVersion: string) {
        var request = AddHospitalPrescriptionRefillRequest.ParseAddHospitalPrescriptionRefillRequest(hospitalPrescriptionId, hospitalPrescriptionRefillStatusId, this.currentHospital!.hospitalId, hospitalPrescriptionRowVersion);

        return yield HospitalService.createHospitalPrescriptionRefill(
            this.currentHospital!.hospitalId,
            request)
            .then(NotificationStoreInstance.onSuccess(request.hospitalPrescriptionRefillStatusId == HospitalPrescriptionRefillStatus.PendingPickup ? "Prescription is pending pick up" : "Prescription is ready for pick up"))
            .catch(NotificationStoreInstance.onError("Failed to create Prescription Refill.", undefined));
    });

    checkoutHospitalPrescriptionRefill = flow(function* (this: HospitalPrescriptionRefillStore, hospitalPrescriptionRefillId: number, hospitalPrescriptionRefillRowVersion: string, hospitalPrescriptionRowVersion: string) {
        var request = CheckOutHospitalPrescriptionRefillRequest.ParseCheckOutHospitalPrescriptionRefillRequest(hospitalPrescriptionRefillId, hospitalPrescriptionRefillRowVersion, hospitalPrescriptionRowVersion);

        return yield HospitalService.checkOutHospitalPrescriptionRefill(
            this.currentHospital!.hospitalId,
            request)
            .then(NotificationStoreInstance.onSuccess("Prescription checked out"))
            .catch(NotificationStoreInstance.onError("Failed to check out Prescription.", undefined));
    });

    updateHospitalPrescriptionRefill = flow(function* (this: HospitalPrescriptionRefillStore, hospitalPrescriptionRefillId: number, hospitalPrescriptionId: number, hospitalPrescriptionRefillStatusId: number, hospitalPrescriptionRowVersion: string, rowVersion: string) {
        var request = UpdateHospitalPrescriptionRefillRequest.ParseUpdateHospitalPrescriptionRefillRequest(hospitalPrescriptionRefillId, hospitalPrescriptionId, hospitalPrescriptionRefillStatusId, hospitalPrescriptionRowVersion, rowVersion);

        return yield HospitalService.updateHospitalPrescriptionRefill(
            this.currentHospital!.hospitalId,
            request)
            .then(NotificationStoreInstance.onSuccess("Prescription updated"))
            .catch(NotificationStoreInstance.onError("Failed to update Prescription.", undefined));
    });
}
